export default __webpack_public_path__ + "static/media/classroomImg4.58f4ab64.svg";